import React, { useEffect } from "react";
import "./FilterButton.css";
import { useAppDispatch } from "src/hooks/redux/hooks";
import { setOrderTypeValue, setRequirementType, setSupportValue, setWithdrawOptionValue } from "src/store/requirement/requirement";

type Checked = {
   name: string;
   options: string[]; // Add options prop to accept the array
   onOptionChange?: (option: string) => void; // Add a callback function prop
   type: string;
};

const FilterButton = ({ name, options, onOptionChange, type }: Checked) => {
   const dispatch = useAppDispatch()

   return (
      <div className="d-flex align-items-center justify-content-center">
         <div className="radio-inputs">
            {options.map((option) => (
               <label className="radio" key={option}>
                  <input
                     type="radio"
                     name="radio"
                     checked={name === option}
                     onChange={() => {
                        // onOptionChange(option);
                        // console.log(options)
                        if (type === "requirement") {
                           // console.log("requirement: ", option)
                           dispatch(setRequirementType(option));
                        }
                        else if (type === "support") {
                           // console.log("support: ", option)
                           dispatch(setSupportValue(option));
                        }
                        else if (type === "doorstepOrder") {
                           // console.log("doorstepOrder: ", option)
                           dispatch(setOrderTypeValue(option))
                        }
                        else if (type === "withdraw") {
                           // console.log("withdrawType: ", option)
                           dispatch(setWithdrawOptionValue(option))
                        }

                     }} // Trigger state change on click
                  />
                  <span className="name">
                     {option}
                  </span>
               </label>
            ))}
         </div>
      </div>
   );
};
export default FilterButton;
